import React from 'react';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';

import { EXTERNAL_LINKS, AUTH_LOGIN_URL } from '../../app-config';
import { DSButton } from '../Button/Button';
import { useDrawerStyles } from './styles';

type PropsType = {
  onCreateAccount: () => void;
};

const NavDrawer: React.FC<PropsType> = ({ onCreateAccount }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const classes = useDrawerStyles();

  return (
    <Grid
      className={classes.drawer}
      container
      direction={matches ? 'row' : 'column'}
      spacing={6}
      justifyContent={matches ? 'center' : 'flex-start'}
      alignItems={matches ? 'center' : 'flex-start'}
    >
      <Grid item>
        <a
          className={classes.link}
          href={EXTERNAL_LINKS.dataswiftDocs}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography color="textPrimary" variant="h6">
            Docs
          </Typography>
        </a>
      </Grid>

      <Grid item>
        <a
          className={classes.link}
          href={EXTERNAL_LINKS.datasiwftAPI}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography color="textPrimary" variant="h6">
            API
          </Typography>
        </a>
      </Grid>
      <Grid item>
        <a
          className={classes.link}
          href={EXTERNAL_LINKS.hubGithub}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography color="textPrimary" variant="h6">
            Github
          </Typography>
        </a>
      </Grid>

      <Grid item>
        <a className={`${classes.link} login`} href={AUTH_LOGIN_URL}>
          <Typography color="textPrimary" variant="h6">
            Log in
          </Typography>
        </a>
      </Grid>

      <Grid item>
        <DSButton className={classes.createAccount} onClick={onCreateAccount}>
          Create Account
        </DSButton>
      </Grid>
    </Grid>
  );
};

export default NavDrawer;
